/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable global-require */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { JoinOutline16 } from '@hb/coffee-icons';
import { Toast } from '@hb/coffee';
import { namespace } from 'vuex-class';
import {
  Component, Prop, Mixins,
} from 'vue-property-decorator';
import SelectCardApi from '@/api/cardBind';
import { RouterV2Enum } from '@/router/router-names';
import { ubtPageButton } from '@/shared/utils/ubt';
import type { SessionFrom } from '@/views_v2/card-list/types';
import { FormInfomation } from '@/views_v2/card-list/types';

import RouterHelper from '@/shared/utils/routerHelper';
import FinanceBusiness from '@/mixins/finance-business';

import router from '@/router';
import { jumpToNewVersion } from '@/shared/utils/jumpTo';
import { SelectCardInfo } from '@/api/cardBind/types';
import { closeWebView, nativeLocalSetData } from '@/api/native/utils';

const style = require('./index.module.scss') as Dictionary;
const defaultLogo = require('./images/card@3x.png');

const ApplyProductStore = namespace('applyProduct');

@Component({ name: 'CardBankList' })
export default class CardBankList extends Mixins(
  FinanceBusiness,
) {
  @Prop(String) readonly entryFrom!: FormInfomation;

  @Prop(String) readonly commodityId!: string;

  @Prop(String) readonly capitalCode!: string;

  @Prop(String) readonly loanOrderId!: string;

  @Prop(Object) readonly sessionFrom!: SessionFrom;

  // 用户选择银行卡前的来源页面，目前只适配于还款流程
  @Prop(String) readonly fromPath!: string;

  // 用户选择银行后的返回页面，目前只适配于还款流程
  @Prop(String) readonly backPath!: string;

  // 用于选择银行卡后继续前进的页面，目前只适配于还款流程
  @Prop(String) readonly forwardUrl!: string;

  /** 列表标题 */
  @Prop(String) readonly cardListTitle?: string;

  /** 底部添加按钮标题 */
  @Prop(String) readonly cardAddTitle?: string;

  /** 回退时的history序列 */
  @Prop(String) readonly fromHistoryLength!: string;

  /** 是否-预授信流程 */
  @Prop(Boolean) readonly isPreCredit!: boolean;

  @Prop(Boolean) readonly ocrAfterLoan!: boolean;

  @ApplyProductStore.Action('$updateState') updateLoanBankCard!: (
    data: Dictionary
  ) => void;

  public cardList: SelectCardInfo[] = [];

  private async created() {
    if (this.commodityId) {
      this.cardList = await SelectCardApi.getSelectCardList({
        cardType: 0,
        commodityId: String(this.commodityId),
        capitalCode: this.capitalCode,
        loanOrderId: this.loanOrderId,
        scene: this.entryFrom === FormInfomation.Product || this.entryFrom === FormInfomation.QuickWithdraw ? 'loan' : '',
      }) as unknown as SelectCardInfo[];

      // 选择银行卡--判断是否有卡列表，如果没有 则去新增银行卡
      if (!this.cardList.length) {
        ubtPageButton(
          this,
          'finance_selectBankCard_addCard',
          'entryFrom',
          this.entryFrom,
          'productId',
          this.commodityId,
        );

        this.$router.replace({
          path: RouterV2Enum.cardBind,
          query: {
            from: this.entryFrom,
            commodityId: String(this.commodityId),
            capitalCode: this.capitalCode,
            forwardUrl: this.forwardUrl,
            loanOrderId: this.loanOrderId,
            isPreCredit: String(this.isPreCredit),
            ocrAfterLoan: String(this.ocrAfterLoan),
          },
        });
      } else if (this.entryFrom === FormInfomation.Credit) {
        Toast('请选择收款账户');
      }
    } else {
      Toast('没有找到产品ID');
    }
  }

  // 选择银行卡
  private async onSelectedBank(item: SelectCardInfo) {
    if (!item.support) {
      Toast('该卡不支持，请新增或选择其他银行卡');
      return;
    }

    this.$ubtPageButton(
      '臻有钱_选择银行卡_选择银行卡',
      'productId',
      this.commodityId,
    );

    /**
     * entryFrom===FormInfomation.Credit为授信结果提前进行自营绑卡场景，只有自营8180没有绑卡记录才会跳转此页面
     * 不会走进下面逻辑
     */
    if (item.isBind) {
      if (this.entryFrom === FormInfomation.Product) {
        this.$ubtPageButton(
          '臻有钱_选择银行卡_选择银行卡_回到提现申请页',
          'productId',
          this.commodityId,
        );

        this.updateLoanBankCard({
          bankCard: {
            bankName: item.bankName,
            bankNo: item.cardNo.slice(-4),
            bankIcon: item.extendInfo ? item.extendInfo.logo || '' : '',
            bankId: item.id,
          },
        });

        RouterHelper.backToPath(this.sessionFrom.back);
      } else if (this.entryFrom === FormInfomation.Repay) {
        this.$ubtPageButton(
          'finance_repay_selectBankCard_backRepay',
          'commodityId',
          this.commodityId,
        );
        const bankId = item.id;

        if (this.sessionFrom) {
          RouterHelper.navigate(this.sessionFrom ? this.sessionFrom.back : this.fromPath);
        } else if (this.forwardUrl) {
          jumpToNewVersion(this.forwardUrl, false, `cardId=${bankId}&bankMobile=${item.bankMobile}`);
        } else {
          const path = `${this.backPath}&cardId=${bankId}&bankMobile=${item.bankMobile}`;
          localStorage.setItem('bankData', path);
          router.go(-1);
        }
      } else if (this.entryFrom === FormInfomation.QuickWithdraw) {
        /** 快速提现流程-新开Webview链路 */
        this.$ubtPageButton(
          '臻有钱_选择银行卡_选择银行卡_回到提现申请页',
          'productId',
          this.commodityId,
        );
        /** 设置本地缓存，银行卡信息 */
        await nativeLocalSetData({
          key: FormInfomation.QuickWithdraw,
          /** 兜底处理，避免值没有的时候，导致本地缓存设置失败 */
          value: [item.bankName || '', item.cardNo.slice(-4) || '', item.extendInfo ? item.extendInfo.logo || '' : '', item.id || ''],
        });
        /** 关闭webview，返回到快速提现页面，后面再加h5回退的逻辑 */
        await closeWebView();
      }
    } else {
      Toast({
        duration: 1500,
        message: '请先完成银行卡验证',
      });

      this.$nextTick(() => {
        this.$router.push({
          path: RouterV2Enum.cardBind,
          query: {
            from: this.entryFrom,
            commodityId: String(this.commodityId),
            userBankId: item.id,
            backPath: this.backPath,
            fromPath: RouterV2Enum.cardList,
            capitalCode: this.capitalCode,
            forwardUrl: this.forwardUrl,
            loanOrderId: this.loanOrderId,
            isPreCredit: String(this.isPreCredit),
            ocrAfterLoan: String(this.ocrAfterLoan),
          },
        });
      });
    }
  }

  // 新增
  private onBankCard() {
    const buttonName = `臻有钱_选择银行卡_${[FormInfomation.Product, FormInfomation.QuickWithdraw].includes(this.entryFrom) ? '提现' : '还款'}_新增银行卡`;
    this.$ubtPageButton(
      buttonName,
      'productId',
      this.commodityId,
    );


    const queryParams = {
      from: this.entryFrom,
      commodityId: String(this.commodityId),
      backPath: this.backPath,
      fromPath: RouterV2Enum.cardList,
      capitalCode: this.capitalCode,
      forwardUrl: this.forwardUrl,
      loanOrderId: this.loanOrderId,
      fromHistoryLength: this.fromHistoryLength,
      isPreCredit: this.isPreCredit ? 'true' : 'false',
      ocrAfterLoan: String(this.ocrAfterLoan),
    };

    this.$router.push({
      path: RouterV2Enum.cardBind,
      query: queryParams,
    });
  }

  private renderCardList(item: SelectCardInfo) {
    const bankLogo = (item.extendInfo || {}).logo || defaultLogo;
    const itemOpacityStyle = item.support ? 1 : '0.4';

    return (
      <div class={style.card_bank_List_all}>
        <div
          class={style.bank_info_list}
          style={{
            opacity: itemOpacityStyle,
          }}
          onClick={this.onSelectedBank.bind(this, item)}
        >
          <div class={style.img_bank}>
            <div class={style.bank_img}>
              <img src={bankLogo} width="70%" />
            </div>
            <span>
              <span>{item.bankName}</span>&nbsp;
              <span>{item.cardType === 0 ? '储蓄卡' : '信用卡'}</span>(
              {item.cardNo})
            </span>
          </div>
        </div>
      </div>
    );
  }

  private render() {
    return (
      <div class={style.cardList}>
        <div class={style.cardListTitle}>{this.cardListTitle}</div>
        <div class={style.bank_list}>
          {this.cardList.map((item: SelectCardInfo) => this.renderCardList(item))}
          <div class={style.add_card_list} onClick={this.onBankCard.bind(this)}>
            <JoinOutline16 class={style.add_card_icon} />
            &nbsp;
            <span class={style.add_card_title}>{this.cardAddTitle}</span>
          </div>
        </div>
      </div>
    );
  }
}
